import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-qr-code-sharp",
  "use": "icon-qr-code-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-qr-code-sharp\"><title>Qr Code</title><path d=\"M336 336h80v80h-80zM272 272h64v64h-64zM416 416h64v64h-64zM432 272h48v48h-48zM272 432h48v48h-48zM336 96h80v80h-80z\" /><path d=\"M480 240H272V32h208zm-164-44h120V76H316zM96 96h80v80H96z\" /><path d=\"M240 240H32V32h208zM76 196h120V76H76zM96 336h80v80H96z\" /><path d=\"M240 480H32V272h208zM76 436h120V316H76z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol